import React from 'react';
import ThreadMiner from './ThreadMiner';

const ThreadDashboard = ({ data }) => {
  if (!data) return null;

  // Génère les slots de 0 à 19
  const gridSlots = Array.from({ length: 20 }, (_, i) => i);

const formatTime = (seconds) => {
  if (!seconds || seconds <= 0) return "0s";

  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  // Si on a moins d'une minute, on affiche uniquement les secondes
  if (mins === 0) {
    return `${secs}s`;
  }

  // Sinon, on affiche minutes et secondes
  return `${mins}m ${secs.toString().padStart(2, '0')}s`;
};

  return (
    <div className="p-4 bg-[#0a0a0c] min-h-screen text-gray-300 font-sans">
      {/* Header compact pour Desktop */}
<div className="mb-6 flex items-center justify-between bg-[#111114] p-6 rounded-xl border border-gray-800 shadow-2xl">
  <div className="flex gap-10"> {/* Augmentation du gap pour laisser respirer le texte plus grand */}
    <div>
      <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">Status Global</p>
      <p className="text-lg font-bold text-white flex items-center gap-2">
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse" />
        {data.global_state}
      </p>
    </div>

    <div>
      <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">Mined / Total</p>
      <p className="text-lg font-mono text-blue-400">
        {data.nb_mined} <span className="text-gray-600">/</span> {data.total}
      </p>
    </div>

    <div>
      <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">Temps restant</p>
<p className="text-lg font-mono text-blue-400">~ {formatTime(data.eta_seconds)}</p>    </div>
  </div>

  <div className="flex gap-4">
    <div className="text-right">
      <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">CPU Load</p>
      <p className="text-lg font-mono text-orange-400">{data.cpu}%</p>
    </div>
  </div>
</div>

      {/* GRILLE 5x4 - Optimisée Desktop */}
      <div className="grid grid-cols-5 gap-3">
        {gridSlots.map((id) => {
          const thread = data?.threads?.find((t) => t.layout_id === id);
          return (
            <div key={id} className="relative group">
              {thread ? (
                <ThreadMiner {...thread} />
              ) : (
                // Slot Vide (Placeholder)
                <div className="h-[140px] border border-gray-900 bg-gray-900/10 rounded-lg flex flex-col items-center justify-center group-hover:bg-gray-900/20 transition-all">
                  <span className="text-[10px] font-mono text-gray-800">SLOT_{id.toString().padStart(2, '0')}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThreadDashboard;